import React, { useState } from 'react';

import Intro2023 from '../../../assets/svg-components/intro/2023.svg';
import ShareIcon from '../../../assets/svg-components/intro/share_icon.svg';
import SiteGroundLogo from '../../../assets/svg-components/intro/siteground-logo.svg';
import { Kaleidoscope } from '../../../components/kaleidoscope/kaleidoscope';
import ShareDialog from '../../../components/share-dialog/share-dialog';
import { Text } from '../../../components/text/text';
import { Title } from '../../../components/title/title';
import { Translate } from '../../../components/translate';
import './intro.scss';

export const IntoSection = ({ children }: { children?: any }) => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  return (
    <div className="rc-intro-section">
      <Kaleidoscope className="rc-intro-section__kaleidoscope-mobile" />

      <div className="rc-intro-section__content-wrapper">
        <Kaleidoscope className="rc-intro-section__kaleidoscope rc-intro-section__kaleidoscope--left" />
        <Kaleidoscope className="rc-intro-section__kaleidoscope rc-intro-section__kaleidoscope--right" />

        <div className="rc-intro-section__siteground-logo">
          <SiteGroundLogo />
        </div>
        <Title className="rc-intro-section__content-title" weight="bold" align="center">
          <Intro2023 className="rc-intro-section__content-title__background" />
          <Translate id="translate.intro.section.title" />
        </Title>
        <Text className="rc-intro-section__content-description" size="large">
          <Translate id="translate.intro.section.text" />
        </Text>

        {children}
      </div>
      <div onClick={() => setIsDialogOpen(true)} className="rc-intro-section__share-button">
        <ShareIcon className="rc-intro-section__share-button-icon" />
        <Text align="center" weight="bold" className="rc-intro-section__share-button-text">
          <Translate id="translate.general.share" />
        </Text>
      </div>
      <ShareDialog isOpen={isDialogOpen} setIsDialogOpen={setIsDialogOpen} />
      {/*<SnowEffect />*/}
    </div>
  );
};
